// Get the token
const getAuthToken = () => {
  return localStorage.getItem("token");
};

// Base URL from environment variable
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// POST: Register new dealer
export const registerDealer = async (data) => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${BASE_URL}/dealers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Registration failed");
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// GET: Fetch Dealers
export const getDealers = async () => {
  const token = getAuthToken();
  try {
    const response = await fetch(`${BASE_URL}/dealers`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const contentType = response.headers.get("content-type");

    if (!response.ok) {
      let errorMessage = "Failed to fetch dealers";
      if (contentType && contentType.includes("application/json")) {
        const errorData = await response.json();
        errorMessage = errorData.message || errorMessage;
      } else {
        const errorText = await response.text();
        console.error("Raw response:", errorText);
      }
      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error.message);
    throw error;
  }
};
